'use client';

import { Monitor, Moon, Sun } from 'lucide-react';
import { useTheme } from 'next-themes';
import { useEffect, useState } from 'react';

import { ToggleGroup, ToggleGroupItem } from '@/components/ui/toggle-group';

export function ThemeSwitcher() {
  const [mounted, setMounted] = useState(false);
  const { theme, setTheme } = useTheme();

  // useEffect only runs on the client, so now we can safely show the UI
  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) {
    return <div className="h-10"></div>;
  }

  return (
    <ToggleGroup
      type="single"
      value={theme}
      onValueChange={(value) => {
        if (value) setTheme(value);
      }}
      className="inline-flex gap-0 border rounded-full p-1 bg-background"
    >
      <ToggleGroupItem
        value="light"
        aria-label="Cambiar a tema claro"
        className="data-[state=on]:bg-accent data-[state=on]:text-foreground rounded-full h-9 px-3"
      >
        <Sun className="size-4" />
      </ToggleGroupItem>
      <ToggleGroupItem
        value="system"
        aria-label="Cambiar a tema sistema"
        className="data-[state=on]:bg-accent data-[state=on]:text-foreground rounded-full h-9 px-3"
      >
        <Monitor className="size-4" />
      </ToggleGroupItem>
      <ToggleGroupItem
        value="dark"
        aria-label="Cambiar a tema oscuro"
        className="data-[state=on]:bg-accent data-[state=on]:text-foreground rounded-full h-9 px-3"
      >
        <Moon className="size-4" />
      </ToggleGroupItem>
    </ToggleGroup>
  );
}
